import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faBullseye, faChevronDown, faLocation, faTrain, faSchool, faLandmark } from '@fortawesome/free-solid-svg-icons';

function PostAdSectionTwo({
  formData,
  handleChange,
  getLocalizedText,
  currentLanguage,
  // Props for Location Logic
  cities,
  allRegions,
  citySelectorRef,
  isCityDropdownOpen,
  setIsCityDropdownOpen,
  handleCitySelect,
  regionSelectorRef,
  setShowTooltip,
  showTooltip,
  isRegionDropdownOpen,
  setIsRegionDropdownOpen,
  handleRegionSelect,
  searchBarRef,
  handleAddressClick,
  isSearchDropdownOpen,
  handleSearchOptionSelect,
  errorMessage,
  suggestions,
  handleSuggestionSelect,
  amenitiesList,
  policyOptions,
  showPostAdFeatureModal,
  setShowPostAdFeatureModal,
  postAdFeatureType,
  setPostAdFeatureType,
  setIsSearchDropdownOpen,
  isFieldValid
}) {
  return (
    <>
     {/* Amenities */}
      <div className="filter-section">
        <h3>{getLocalizedText('المرافق', 'Amenities')}</h3>
        <div className="filter-options-group amenities-options">
          {amenitiesList.map(option => ( // Refactored: Dynamic map
            <div className="filter-option" key={option.value}>
              <input
                type="checkbox"
                id={option.value}
                name={`amenities_${option.value}`} // Dynamic name
                checked={formData[`amenities_${option.value}`]}
                onChange={handleChange}
              />
              <label htmlFor={option.value}>{getLocalizedText(option.ar, option.en)}</label>
            </div>
          ))}
        </div>
      </div>

      {/* Cleaning Policy Explanation */}
      <div className="form-group">
        <label htmlFor="cleaningExplanation">
          {getLocalizedText(
            'اشرح كيف تدار عملية النظافة خلال فترة الإقامة',
            'Explain how cleaning is managed during the period of residence'
          )}
          <span className={`required-indicator ${isFieldValid('cleaning_explanation') ? 'valid-check' : 'required-star'}`}>
            {isFieldValid('cleaning_explanation') ? '✓' : '*'}
          </span>
        </label>
        <textarea
          id="cleaningExplanation"
          name="cleaning_explanation"
          value={formData.cleaning_explanation}
          onChange={handleChange}
          placeholder={getLocalizedText(
            'مثال:\n• كل ساكن مسؤول عن تنظيف مساحته الخاصة.\n• يتم تنظيف الأماكن المشتركة وفق جدول متفق عليه.\n• يأتي عامل نظافة لتنظيف الشقة مرة واحدة أسبوعيًا.',
            'Example:\n• Each guest is responsible for cleaning their own space.\n• Common areas are cleaned on a shared schedule.\n• A cleaner visits once a week.'
        )}
          minLength="50"
          maxLength="750"
        ></textarea>
        <div className="description-hint">
          {getLocalizedText(
            'اقل حد 50 حرف - اكثر حد 750 حرف',
            'Minimum 50 characters - Maximum 750 characters'
          )}
        </div>
      </div>

      {/* Policies */}
      <div className="filter-section policies-section">
        <div className="policies-row">
          <div className="policy-item">
            <div className="policy-row">
              <span className="policy-label">
                {getLocalizedText('سياسة التدخين', 'Smoking Policy')}
                <span className={`required-indicator ${isFieldValid('smoking_policy') ? 'valid-check' : 'required-star'}`}>
                  {isFieldValid('smoking_policy') ? '✓' : '*'}
          </span>
              </span>
              <span className="policy-spacer"></span>
              {policyOptions.map(option => ( // Refactored: Dynamic map
                <React.Fragment key={`smoking_${option.value}`}>
                  <div className="filter-option">
                    <input
                      type="radio"
                      id={`smoking_${option.value}`}
                      name="smoking_policy"
                      value={option.value}
                      checked={formData.smoking_policy === option.value}
                      onChange={handleChange}
                    />
                    <label htmlFor={`smoking_${option.value}`}>{getLocalizedText(option.ar, option.en)}</label>
                  </div>
                  <span className="policy-spacer"></span>
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className="policy-item">
            <div className="policy-row">
              <span className="policy-label">
                {getLocalizedText('سياسة الزوار', 'Visitors Policy')}
                <span className={`required-indicator ${isFieldValid('visitors_policy') ? 'valid-check' : 'required-star'}`}>
                  {isFieldValid('visitors_policy') ? '✓' : '*'}
                </span>
                </span>
              <span className="policy-spacer"></span>
              {policyOptions.map(option => (
                <React.Fragment key={`visitors_${option.value}`}>
                  <div className="filter-option">
                    <input
                      type="radio"
                      id={`visitors_${option.value}`}
                      name="visitors_policy"
                      value={option.value}
                      checked={formData.visitors_policy === option.value}
                      onChange={handleChange}
                    />
                    <label htmlFor={`visitors_${option.value}`}>{getLocalizedText(option.ar, option.en)}</label>
                  </div>
                  <span className="policy-spacer"></span>
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className="policy-item">
            <div className="policy-row">
              <span className="policy-label">
                {getLocalizedText('سياسة الحيوانات الأليفة', 'Pets Policy')}
                <span className={`required-indicator ${isFieldValid('pets_policy') ? 'valid-check' : 'required-star'}`}>
                   {isFieldValid('pets_policy') ? '✓' : '*'}
                </span>
                </span>
              <span className="policy-spacer"></span>
              {policyOptions.map(option => (
                <React.Fragment key={`pets_${option.value}`}>
                  <div className="filter-option">
                    <input
                      type="radio"
                      id={`pets_${option.value}`}
                      name="pets_policy"
                      value={option.value}
                      checked={formData.pets_policy === option.value}
                      onChange={handleChange}
                    />
                    <label htmlFor={`pets_${option.value}`}>{getLocalizedText(option.ar, option.en)}</label>
                  </div>
                  <span className="policy-spacer"></span>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Section 3: Price, Insurance */}
      <div className="section-group">
        <div className="filter-section no-border">
          <h3>
            {getLocalizedText('سعر الإيجار', 'Rent Price')}
            <span className={`required-indicator ${isFieldValid('price_type') ? 'valid-check' : 'required-star'}`}>
              {isFieldValid('price_type') ? '✓' : '*'}
            </span>
            </h3>
          <div className="price-range-inputs">
            <input
              type="number"
              placeholder={getLocalizedText('ادخل السعر (ج.م)', 'Enter Price (EGP)')}
              className="price-input"
              name="price"
              value={formData.price}
              onChange={handleChange}
            />
          </div>
          <div className="filter-options-group">
            <div className="filter-option">
              <input
                type="radio"
                id="daily"
                name="price_type"
                value="daily"
                checked={formData.price_type === 'daily'}
                onChange={handleChange}
              />
              <label htmlFor="daily">{getLocalizedText('يومياً', 'Daily')}</label>
              <div className="including-bills-option">
                <input
                  type="checkbox"
                  id="includingBills"
                  name="price_includes_bills"
                  checked={formData.price_includes_bills}
                  onChange={handleChange}
                />
                <label htmlFor="includingBills">{getLocalizedText('يشمل الفواتير', 'Including Bills')}</label>
              </div>
            </div>
            <div className="filter-option">
              <input
                type="radio"
                id="weekly"
                name="price_type"
                value="weekly"
                checked={formData.price_type === 'weekly'}
                onChange={handleChange}
              />
              <label htmlFor="weekly">{getLocalizedText('أسبوعياً', 'Weekly')}</label>
            </div>
            <div className="filter-option">
              <input
                type="radio"
                id="monthly"
                name="price_type"
                value="monthly"
                checked={formData.price_type === 'monthly'}
                onChange={handleChange}
              />
              <label htmlFor="monthly">{getLocalizedText('شهرياً', 'Monthly')}</label>
            </div>
          </div>
          <div className="form-note">
            {getLocalizedText(
              'يرجى إدخال إجمالي المبلغ الشهري الذي سيدفعه المستأجر، بما في ذلك أي رسوم إضافيةرسوم الادارة إن وجدت.',
              'Please enter the total monthly amount the tenant will pay, including any manging fees if existed.'
            )}
          </div>
        </div>

        <div className="filter-section">
          <h3>
            {getLocalizedText('التأمين القابل للاسترداد', 'Refundable Insurance')}
            <span className={`required-indicator ${isFieldValid('insurance') ? 'valid-check' : 'required-star'}`}>
              {isFieldValid('insurance') ? '✓' : '*'}
            </span>
          </h3>
          <div className="price-range-inputs">
            <input
              type="number"
              placeholder={getLocalizedText('ادخل السعر (ج.م)', 'Enter Price (EGP)')}
              className="price-input"
              name="insurance"
              value={formData.insurance}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="section-divider"></div>
      </div>
      {/* Section 4: Location & Contact */}
      <div className="section-group">
        <div className="form-group stacked-fields">
          <div className="post-ad-location-selector-wrapper">
            <div
              className="post-ad-city-selector-wrapper"
              ref={citySelectorRef}
              onClick={() => setIsCityDropdownOpen(!isCityDropdownOpen)}
            >
              <div className="post-ad-city-display">
                <FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginInlineEnd: '3px', color: '#cc0000' }} />
                <span>
                  {formData.city
                    ? getLocalizedText(
                        cities.find(city => city.en === formData.city)?.ar,
                        formData.city
                      )
                    : getLocalizedText('المدينة', 'City')}
                </span>
                <FontAwesomeIcon icon={faChevronDown} className="post-ad-dropdown-icon" style={{ color: '#000000' }} />
              </div>
              {isCityDropdownOpen && (
                <div className="post-ad-city-dropdown-menu">
                  {cities.map((city, index) => (
                    <div
                      key={index}
                      className="post-ad-city-dropdown-item"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCitySelect(city);
                      }}
                    >
                      {getLocalizedText(city.ar, city.en)}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div
              className="post-ad-region-selector-wrapper"
              ref={regionSelectorRef}
              onMouseEnter={() => !formData.city && setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              onClick={() => formData.city && setIsRegionDropdownOpen(!isRegionDropdownOpen)}
            >
              <div className="post-ad-region-display">
                <FontAwesomeIcon icon={faBullseye} style={{ marginInlineEnd: '3px', color: '#cc0000' }} />
                <span>
                  {formData.region
                    ? getLocalizedText(
                        allRegions[formData.city]?.find(region => region.en === formData.region)?.ar,
                        formData.region
                      )
                    : getLocalizedText('المنطقة', 'Region')}
                </span>
                <FontAwesomeIcon icon={faChevronDown} className="post-ad-dropdown-icon" style={{ color: '#000000' }} />
              </div>
              {isRegionDropdownOpen && formData.city && (
                <div className="post-ad-region-dropdown-menu">
                  {allRegions[formData.city]?.map((region, index) => (
                    <div
                      key={index}
                      className="post-ad-region-dropdown-item"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRegionSelect(region);
                      }}
                    >
                      {getLocalizedText(region.ar, region.en)}
                    </div>
                  ))}
                </div>
              )}
              {!formData.city && showTooltip && (
                <div className="post-ad-tooltip">{getLocalizedText('يرجى اختيار المدينة', 'Please Select city')}</div>
              )}
              
            </div>
            <span className={`required-indicator ${isFieldValid('region') ? 'valid-check' : 'required-star'}`}>
                    {isFieldValid('region') ? '✓' : '*'}
                  </span>
          </div>

          <div className="inline-field address-field-wrapper" ref={searchBarRef}>
            <label htmlFor="adLocation">
              {getLocalizedText('إعداد الموقع', 'Location Setting')}
              <span className={`required-indicator ${isFieldValid('ad_location') ? 'valid-check' : 'required-star'}`}>
                {isFieldValid('ad_location') ? '✓' : '*'}
              </span>
              </label>
            <input
              type="text"
              id="adLocation"
              name="ad_location"
              value={formData.ad_location}
              onChange={handleChange}
              onClick={handleAddressClick}
              placeholder={getLocalizedText('أدخل موقعًا تقريبيًا', 'Enter an approximated location')}
              dir={currentLanguage === 'ar' ? 'rtl' : 'ltr'}
            />
            {isSearchDropdownOpen && (
              <div className="post-ad-search-dropdown-menu">
                <div
                  className="post-ad-search-dropdown-item set-location-item"
                  onClick={handleSearchOptionSelect}
                >
                  <FontAwesomeIcon icon={faLocation} style={{ fontSize: '1.1em', marginInlineEnd: '6px', color: '#555' }} />
                  {getLocalizedText('تحديد الموقع على الخريطة', 'Set Location on Map')}
                </div>

                {/* الخيارات الجديدة المحدثة */}
                <div
                  className="post-ad-search-dropdown-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsSearchDropdownOpen(false); // إغلاق الـ dropdown أولاً
                    setPostAdFeatureType('metro');
                    setShowPostAdFeatureModal(true);
                  }}
                >
                  <FontAwesomeIcon icon={faTrain} style={{ fontSize: '1.1em', marginInlineEnd: '6px', color: '#555' }} />
                  {getLocalizedText("محطات مترو", "Metro Stations")}
                </div>

                <div
                  className="post-ad-search-dropdown-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsSearchDropdownOpen(false);
                    setPostAdFeatureType('university');
                    setShowPostAdFeatureModal(true);
                  }}
                >
                  <FontAwesomeIcon icon={faSchool} style={{ fontSize: '1.1em', marginInlineEnd: '6px', color: '#555' }} />
                  {getLocalizedText("الجامعات", "Universities")}
                </div>

                <div
                  className="post-ad-search-dropdown-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsSearchDropdownOpen(false);
                    setPostAdFeatureType('square');
                    setShowPostAdFeatureModal(true);
                  }}
                >
                  <FontAwesomeIcon icon={faLandmark} style={{ fontSize: '1.1em', marginInlineEnd: '6px', color: '#555' }} />
                  {getLocalizedText("الميادين", "Squares")}
                </div>

                {/* باقي الـ suggestions */}
                {errorMessage ? (
                  <div className="post-ad-search-dropdown-item">{errorMessage}</div>
                ) : suggestions.length === 0 && formData.ad_location.length >= 4 ? (
                  <div className="post-ad-search-dropdown-item">{getLocalizedText('لا توجد نتائج', 'No results found')}</div>
                ) : (
                  suggestions.map((suggestion, index) => (
                    <div key={index} className="post-ad-search-dropdown-item" onClick={() => handleSuggestionSelect(suggestion)}>
                      {suggestion.properties.formatted}
                    </div>
                  ))
                )}
              </div>
            )}
          </div>

          <div className="inline-field">
            <label htmlFor="adContactPhone">
              {getLocalizedText('رقم الهاتف', 'Phone Number')}
              <span className={`required-indicator ${isFieldValid('ad_contact_phone') ? 'valid-check' : 'required-star'}`}>
                {isFieldValid('ad_contact_phone') ? '✓' : '*'}
              </span>
              </label>
            <input
              type="tel"
              id="adContactPhone"
              name="ad_contact_phone"
              value={formData.ad_contact_phone}
              onChange={handleChange}
              placeholder={getLocalizedText('01xxxxxxxxx :مثال', 'e.g. 01xxxxxxxxx')}
              maxLength="11"
              pattern="[0-9]*"
            />
          </div>
          <div className="inline-field">
            <label htmlFor="adContactWhatsapp">
              {getLocalizedText('رقم الواتساب', 'WhatsApp Number')}
              <span className={`required-indicator ${isFieldValid('ad_contact_whatsapp') ? 'valid-check' : 'required-star'}`}>
                {isFieldValid('ad_contact_whatsapp') ? '✓' : '*'}
              </span>
            </label>
            <input
              type="tel"
              id="adContactWhatsapp"
              name="ad_contact_whatsapp"
              value={formData.ad_contact_whatsapp}
              onChange={handleChange}
              placeholder={getLocalizedText('01xxxxxxxxx :مثال', 'e.g. 01xxxxxxxxx')}
              maxLength="11"
              pattern="[0-9]*"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default PostAdSectionTwo;